import type { Contact } from '@axiom/validation';
import { Api } from '@axiom/ui';

import { EnvUtil } from '../utils/env-util';
import LegacyApiHelper from '../classes/legacy-api-helper';

const api = new LegacyApiHelper('contacts');

export const getContact = async (contactId: Contact['id']) => {
  const { data: contact } = await api.GET(
    `${EnvUtil.apiEnvoyUrl}/contacts/${contactId}`
  );
  return contact;
};

export const getContacts = async (filterMeta: {
  currentPage: number;
  pageCount: number;
  resultCount: number;
  aggregations: null; // this is always NULL aka we don't use it
}) => {
  const { data, meta } = await api.GET(
    `${EnvUtil.apiEnvoyUrl}/contacts`,
    filterMeta,
    true
  );
  return {
    results: data,
    meta,
  };
};

class ContactsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  readContact(contactId: Contact['id']) {
    return super.read<{ data: Contact }>({
      endpoint: `/contacts/${contactId}`,
      method: 'GET',
    });
  }

  async invalidateContact(contactId: Contact['id']) {
    return super.invalidate(`/contacts/${contactId}`);
  }

  readContacts(query?: { search?: string; page?: number }) {
    return super.read<{
      data: Contact[];
      meta: { currentPage: number; pageCount: number; resultCount: number };
    }>({
      endpoint: `/contacts`,
      query,
      method: 'GET',
    });
  }

  async invalidateContacts() {
    return super.invalidate(`/contacts`);
  }
}

export const ContactsApi = new ContactsApiClass();
